module.exports = __webpack_public_path__ + "static/media/laundryFrequency.6313a2c3.svg";